import mainImg from "../../../assets/folding-braket.webp"; 
import thumb1 from "../../../assets/folding-thumb-one.webp";
import thumb2 from "../../../assets/folding-thumb-two.webp";

import mainImgone from "../../../assets/12-inch-shoft-pro-spring.webp"; 
import thumb3 from "../../../assets/12-inch-shoft-pro-spring.webp";
import thumb4 from "../../../assets/12-inch-shoft-pro-spring.webp";


import mainImgtwo from "../../../assets/9-inch-pro-spring.webp"; 
import thumb5 from "../../../assets/9-inch-pro-spring.webp";
import thumb6 from "../../../assets/9-inch-pro-spring.webp";

import mainImgthree from "../../../assets/10-inch-soft-pro-spring.webp"; 
import thumb7 from "../../../assets/10-inch-soft-pro-spring.webp";
import thumb8 from "../../../assets/10-inch-soft-pro-spring.webp";

import mainImgfour from "../../../assets/bi-fold.webp"; 
import thumb9 from "../../../assets/bi-fold-thumb-one.webp";
import thumb10 from "../../../assets/bi-fold-thumb-two.webp";



export const products = [
  
 {
    code: "FB-01",
    name: " FOLDING BRACKET",
    category: "folding bracket",

    mainImage: mainImg,
    thumbnails: [thumb1, thumb2],

    // ✅ PRICE
    price: "₹290",
    oldPrice: "₹599",
    sku: "7722",
    stock: "In Stock",

    // ✅ LINKS
    catalogue: "/catalogues/folding-bracket.pdf",
    inquiry: "https://wa.me/91919650100908?text=Folding Bracket Inquiry",

    // ✅ VIDEO (optional - change if needed)
    video: "https://www.youtube.com/embed/avZyqWosVsw",

    // ✅ DESCRIPTION
    short:
      "Folding Bracket is a space-saving wall-mounted support solution designed for foldable shelves, tables, and workstations. Built with high-strength metal, it provides excellent load capacity, stability, and durability. Its foldable mechanism allows easy operation, making it ideal for compact spaces in homes, offices, and commercial interiors.",

    // ✅ FEATURES
    features: [
      "Heavy-duty metal construction for strong support",
      "Foldable design saves space when not in use",
      "Ideal for wall-mounted shelves and tables",
      "Smooth locking and folding mechanism",
      "High load-bearing capacity",
      "Perfect for homes, kitchens, and workstations"
    ],

    // ✅ SPECIFICATIONS
    specifications: [
      { label: "Material", value: "Steel / Metal" },
      { label: "Usage", value: "Wall Shelf Support" },
      { label: "Mounting", value: "Wall Mounted" },
      { label: "Finish", value: "Powder Coated" }
    ],

    // ✅ SPEC TABLE
    specTable: [
      {
        item: "Folding Bracket",
        code: "7722",
        size: "8\" ",
        finish: "Black"
      },
      {
        item: "Folding Bracket",
        code: "7723",
        size: "12\" ",
        finish: "Black"
      },
      {
        item: "Folding Bracket",
        code: "7724",
        size: "16\" ",
        finish: "Black"
      },
      {
        item: "Folding Bracket",
        code: "7768",
        size: "20\" ",
        finish: "Black"
      },
       {
        item: "Folding Bracket",
        code: "7726",
        size: "24\" ",
        finish: "Black"
      },
      
    ],

    // ✅ FAQ
    faq: [
      {
        question: "What is a Folding Bracket?",
        answer:
          "It is a wall-mounted support bracket used for foldable shelves, tables, and workstations."
      },
      {
        question: "Where can it be used?",
        answer:
          "It can be used in kitchens, study tables, wall shelves, and compact spaces."
      },
      {
        question: "What is the benefit of folding brackets?",
        answer:
          "They save space by folding flat when not in use."
      },
      {
        question: "Is it strong enough?",
        answer:
          "Yes, it is made from heavy-duty metal and supports significant weight."
      },
      {
        question: "Is installation easy?",
        answer:
          "Yes, it can be easily installed with standard wall mounting hardware."
      }
    ]
  },
  
  
  {
  code: "7381",
  name: "12\" SOFT PRO SPRING",
  category: "folding bracket",

  mainImage: mainImgone,
  thumbnails: [thumb3, thumb4],

  // ✅ PRICE
  price: "₹334",
  oldPrice: "₹699",
  sku: "7678",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/catalogues/soft-pro-spring.pdf",
  inquiry: "https://wa.me/919650100908?text=12 Inch Soft Pro Spring Inquiry",

  // ✅ VIDEO (change if needed)
  video: "https://www.youtube.com/embed/JPrDQv8qXtg",

  // ✅ DESCRIPTION (improved)
  short:
    "12\" Soft Pro Spring is a high-performance soft-close mechanism designed for drawers, cabinets, and modular furniture. It ensures smooth, controlled, and silent closing while preventing slamming and reducing wear and tear. Built with premium materials, it enhances durability, comfort, and overall user experience in modern kitchens and storage systems.",

  // ✅ FEATURES (optimized)
  features: [
    "Soft-close mechanism for smooth and silent closing",
    "Prevents slamming and protects furniture",
    "High-quality durable construction",
    "Improves lifespan of drawers and cabinets",
    "Suitable for modular kitchens and wardrobes",
    "Enhances comfort and premium feel"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Size", value: "12 Inch" },
    { label: "Material", value: "Metal + Spring Mechanism" },
    { label: "Usage", value: "Drawer / Cabinet Soft Close" },
    { label: "Installation", value: "Side Mount / Internal" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Soft Pro Spring",
      code: "7678",
      size: "100N - 10kgs",
      finish: ""
    },
    {
      item: "Soft Pro Spring",
      code: "7679",
      size: "150N - 15kgs",
      finish: ""
    },
    {
      item: "Soft Pro Spring",
      code: "7680",
      size: "200N - 20kgs",
      finish: ""
    },
    {
      item: "Soft Pro Spring",
      code: "7681",
      size: "250N - 25kGS",
      finish: ""
    },
  ],

  // ✅ FAQ (refined)
  faq: [
    {
      question: "What is 12\" Soft Pro Spring?",
      answer:
        "It is a soft-close mechanism used for smooth and silent closing of drawers and cabinets."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is ideal for modular kitchens, wardrobes, cabinets, and furniture systems."
    },
    {
      question: "Does it prevent slamming?",
      answer:
        "Yes, it ensures controlled closing to prevent slamming and damage."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials for long-lasting performance."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it can be easily installed with standard fittings."
    }
  ]
},


  {
  code: "7644",
  name: "9\" SOFT PRO SPRING",
  category: "folding bracket",

  mainImage: mainImgtwo,
  thumbnails: [thumb5, thumb6],

  // ✅ PRICE
  price: "₹200",
  oldPrice: "₹799",
  sku: "7001",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/catalogues/soft-pro-spring.pdf",
  inquiry: "https://wa.me/919650100908?text=9 Inch Soft Pro Spring Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/Ug2QGmogvfc",

  // ✅ DESCRIPTION (improved)
  short:
    "9\" Soft Pro Spring is a compact and efficient soft-close mechanism designed for drawers, cabinets, and modular furniture. It ensures smooth, silent, and controlled closing while preventing slamming and reducing wear on components. Built with high-quality materials, it offers durability, reliability, and enhanced user comfort in modern kitchen and wardrobe systems.",

  // ✅ FEATURES (optimized)
  features: [
    "Smooth and silent soft-close mechanism",
    "Prevents slamming and protects furniture",
    "Compact size suitable for smaller cabinets",
    "Durable and long-lasting construction",
    "Ideal for modular kitchens and wardrobes",
    "Enhances user comfort and premium feel"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Size", value: "9 Inch" },
    { label: "Material", value: "Metal + Spring Mechanism" },
    { label: "Usage", value: "Drawer / Cabinet Soft Close" },
    { label: "Installation", value: "Side Mount / Internal" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Soft Pro Spring",
      code: "7001",
      size: "50N - 5Kgs",
      finish: "Metal / Coated"
    },
     {
      item: "Soft Pro Spring",
      code: "7002",
      size: "100N - 10Kgs",
      finish: "Metal / Coated"
    },
     {
      item: "Soft Pro Spring",
      code: "7003",
      size: "150N - 15Kgs",
      finish: "Metal / Coated"
    },
     {
      item: "Soft Pro Spring",
      code: "7004",
      size: "200N - 20Kgs",
      finish: "Metal / Coated"
    },
    {
      item: "Soft Pro Spring",
      code: "7005",
      size: "250N - 25Kgs",
      finish: "Metal / Coated"
    },
  ],

  // ✅ FAQ (refined)
  faq: [
    {
      question: "What is 9\" Soft Pro Spring?",
      answer:
        "It is a soft-close mechanism used for smooth and silent closing of drawers and cabinets."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is ideal for kitchens, wardrobes, cabinets, and modular furniture."
    },
    {
      question: "Does it prevent slamming?",
      answer:
        "Yes, it ensures controlled closing to prevent damage and noise."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials for long-lasting use."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it can be easily installed with standard fittings."
    }
  ]
},
 
{
  code: "7126",
  name: "10\" SOFT PRO SPRING SOFT CLOSE",
  category: "folding bracket",

  mainImage: mainImgthree,
  thumbnails: [thumb7, thumb8],

  // ✅ PRICE
  price: "₹281",
  oldPrice: "₹849",
  sku: "7673",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/catalogues/soft-pro-spring.pdf",
  inquiry: "https://wa.me/919650100908?text=10 Inch Soft Pro Spring Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/bbmsASe5hBs",

  // ✅ DESCRIPTION (improved)
  short:
    "10\" Soft Pro Spring Soft Close is a premium soft-close mechanism designed for drawers, cabinets, and modular furniture. It ensures smooth, silent, and controlled closing while preventing slamming and reducing wear. Built with high-quality materials, it offers durability, reliability, and enhanced user comfort in modern kitchen and storage systems.",

  // ✅ FEATURES
  features: [
    "Smooth and silent soft-close mechanism",
    "Prevents slamming and protects furniture",
    "Durable and long-lasting construction",
    "Improves usability and comfort",
    "Suitable for modular kitchens and wardrobes",
    "Easy installation with standard fittings"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Size", value: "10 Inch" },
    { label: "Material", value: "Metal + Spring Mechanism" },
    { label: "Usage", value: "Drawer / Cabinet Soft Close" },
    { label: "Installation", value: "Side Mount / Internal" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Soft Pro Spring",
      code: "7673",
      size: "50N - 5Kgs",
      finish: ""
    },
    {
      item: "Soft Pro Spring",
      code: "7674",
      size: "100N - 10Kgs",
      finish: ""
    },
    {
      item: "Soft Pro Spring",
      code: "7675",
      size: "150N - 15Kgs",
      finish: ""
    },
    {
      item: "Soft Pro Spring",
      code: "7676",
      size: "200N - 20Kgs",
      finish: ""
    },
    {
      item: "Soft Pro Spring",
      code: "7677",
      size: "250N - 25Kgs",
      finish: ""
    },
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is 10\" Soft Pro Spring Soft Close?",
      answer:
        "It is a soft-close mechanism that ensures smooth and silent closing of drawers and cabinets."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is suitable for kitchens, wardrobes, cabinets, and modular furniture."
    },
    {
      question: "Does it prevent slamming?",
      answer:
        "Yes, it provides controlled closing to prevent damage and noise."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials for long-lasting performance."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it can be installed easily using standard fittings."
    }
  ]
},
  
 
{
  code: "7127",
  name: "BI - FOLD LIFT UP ",
  category: "folding bracket",

  mainImage: mainImgfour,
  thumbnails: [thumb9, thumb10],

  // ✅ PRICE
  price: "₹281",
  oldPrice: "₹849",
  sku: "7673",
  stock: "In Stock",

  // ✅ LINKS
  catalogue: "/catalogues/soft-pro-spring.pdf",
  inquiry: "https://wa.me/919650100908?text=10 Inch Soft Pro Spring Inquiry",

  // ✅ VIDEO
  video: "https://www.youtube.com/embed/bbmsASe5hBs",

  // ✅ DESCRIPTION (improved)
  short:
    "10\" Soft Pro Spring Soft Close is a premium soft-close mechanism designed for drawers, cabinets, and modular furniture. It ensures smooth, silent, and controlled closing while preventing slamming and reducing wear. Built with high-quality materials, it offers durability, reliability, and enhanced user comfort in modern kitchen and storage systems.",

  // ✅ FEATURES
  features: [
    "Smooth and silent soft-close mechanism",
    "Prevents slamming and protects furniture",
    "Durable and long-lasting construction",
    "Improves usability and comfort",
    "Suitable for modular kitchens and wardrobes",
    "Easy installation with standard fittings"
  ],

  // ✅ SPECIFICATIONS
  specifications: [
    { label: "Size", value: "10 Inch" },
    { label: "Material", value: "Metal + Spring Mechanism" },
    { label: "Usage", value: "Drawer / Cabinet Soft Close" },
    { label: "Installation", value: "Side Mount / Internal" }
  ],

  // ✅ SPEC TABLE
  specTable: [
    {
      item: "Soft Pro Spring",
      code: "7673",
      size: "50N - 5Kgs",
      finish: ""
    },
    {
      item: "Soft Pro Spring",
      code: "7674",
      size: "100N - 10Kgs",
      finish: ""
    },
    {
      item: "Soft Pro Spring",
      code: "7675",
      size: "150N - 15Kgs",
      finish: ""
    },
    {
      item: "Soft Pro Spring",
      code: "7676",
      size: "200N - 20Kgs",
      finish: ""
    },
    {
      item: "Soft Pro Spring",
      code: "7677",
      size: "250N - 25Kgs",
      finish: ""
    },
  ],

  // ✅ FAQ
  faq: [
    {
      question: "What is 10\" Soft Pro Spring Soft Close?",
      answer:
        "It is a soft-close mechanism that ensures smooth and silent closing of drawers and cabinets."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is suitable for kitchens, wardrobes, cabinets, and modular furniture."
    },
    {
      question: "Does it prevent slamming?",
      answer:
        "Yes, it provides controlled closing to prevent damage and noise."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials for long-lasting performance."
    },
    {
      question: "Is installation easy?",
      answer:
        "Yes, it can be installed easily using standard fittings."
    }
  ]
}
  
];
